/**@flow */

import type { PaginationExtendedType } from "@types";

// Hierarchy Admin
export const getActiveHierarchyTree = (state: Object) =>
  (((state || {}).hierarchy || {}).hierarchy || {}).activeHierarchyTree || null;

export const getBufferedBranches = (state: Object) =>
  (((state || {}).hierarchy || {}).hierarchy || {}).bufferedBranches || null;

export const getDraftHierarchyTree = (state: Object) =>
  state.hierarchy.hierarchy.draftHierarchyTree;

export const getDraftHierarchyTreeBranches = (state: Object) => state.hierarchy.hierarchy.branches;

export const getDraftHierarchyTreeChangelog = (state: Object) =>
  ((((state || {}).hierarchy || {}).hierarchy || {}).changelog || {}).content;

export const getNotificationContacts = (state: Object) =>
  state.hierarchy.hierarchy.notificationContacts.content;

export const getNotificationSummary = (state: Object) =>
  state.hierarchy.hierarchy.notificationSummary;

export const getShiftPatterns = (state: Object) => state.hierarchy.hierarchy.shiftPatterns.content;

export const getDraftHierarchyTreeChangelogPagination = (state: Object): PaginationExtendedType => {
  const changelog = (((state || {}).hierarchy || {}).hierarchy || {}).changelog || {};
  return {
    ...changelog.pagination,
    totalPages: changelog.pagination
      ? Math.ceil(changelog.totalElements / changelog.pagination.pageSize)
      : 0,
  };
};

export const getHierarchyModal = (state: Object) =>
  (((state || {}).hierarchy || {}).hierarchy || {}).showHierarchyModal || null;

export const getStep = (state: Object) =>
  (((state || {}).hierarchy || {}).hierarchy || {}).step || null;

export const getselectedOrganisationalUnit = (state: Object) =>
  state.hierarchy.hierarchy.selectedOrganisationalUnit;

export const hierarchyShiftPatternSchema = (state: Object) =>
  state.hierarchy.hierarchy.hierarchyShiftPatternSchema;

export const getSelectedBranch = (state: Object) =>
  (getselectedOrganisationalUnit(state) || {}).data;

export const isAddEditShiftPatternModalVisible = (state: Object) =>
  state.hierarchy.hierarchy.modals.addEditShiftPatternModal.visible;

export const getAssignedShiftPattern = (state: Object) =>
  state.hierarchy.hierarchy.modals.addEditShiftPatternModal.assignedShiftPattern;

export const isAddEditContactModalVisible = (state: Object) =>
  state.hierarchy.hierarchy.modals.addEditContactModal.visible;

export const getSelectedNotificationContact = (state: Object) =>
  state.hierarchy.hierarchy.modals.addEditContactModal.notificationContact;

export const selectConfigureContactValues = (state: Object) =>
  (((state || {}).form || {})["configure-contact"] || {}).values || {};

export const selectAddEditShiftPatternValues = (state: Object) =>
  (((state || {}).form || {})["add-edit-shift-pattern"] || {}).values || {};

export const getSelectedBranchId = (state: Object) =>
  (((((state || {}).hierarchy || {}).hierarchy || {}).selectedOrganisationalUnit || {}).data || {})
    .id;

// Common
export const isLoading = (state: Object) =>
  state.hierarchy.hierarchy.requestsInProgress > 0 ||
  state.hierarchy.changelog.requestsInProgress > 0;

export const getError = (state: Object) => state.data.error;

export const isEditDraftModalOpened = (state: Object) =>
  state.hierarchy.hierarchy.modals.editDraft.visible;

export const isAddDepartmentModalOpened = (state: Object) =>
  state.hierarchy.hierarchy.modals.addDepartment.visible;

export const isMoveDepartmentModalOpened = (state: Object) =>
  state.hierarchy.hierarchy.modals.moveDepartment.visible;

export const isRenameDepartmentModalOpened = (state: Object) =>
  state.hierarchy.hierarchy.modals.renameDepartment.visible;

export const isDeleteDepartmentModalOpened = (state: Object) =>
  state.hierarchy.hierarchy.modals.deleteDepartment.visible;

export const isDeleteDepartmentModalWarningOpened = (state: Object) =>
  state.hierarchy.hierarchy.modals.deleteDepartmentWarning.visible;

export const getDeleteDepartmentModalWarningText = (state: Object) =>
  state.hierarchy.hierarchy.modals.deleteDepartmentWarning.text;

export const getMovedDepatment = (state: Object) =>
  state.hierarchy.hierarchy.modals.moveDepartment.branch;

export const getRenamedDepartment = (state: Object) =>
  state.hierarchy.hierarchy.modals.renameDepartment.branch;

export const getDeleteDepartment = (state: Object) =>
  state.hierarchy.hierarchy.modals.deleteDepartment.branch;

export const isSidebarExpanded = (state: Object) => state.hierarchy.hierarchy.isSidebarExpanded;

export const getSuccessMessage = (state: Object) => state.data.success;

export { getClient } from "@modules/client/selectors";
